<template>
    <div class="kgk-global-progress">
        <h2>Insgesamt gelaufene Kilometer:</h2>

        <div v-if="goal && !loading">
            <!--div id="confetti"></div-->
            <Progress :radius="80" :strokeWidth="20" :value="progress" :overflowValue="overflow" :strokeColor="'#82C800'" :staticProgress="staticProgress">
                <template v-slot:footer>
                    <h1>{{ convertNumberReadable(Math.round(total * 10) / 10) }} / {{ convertNumberReadable(goal,10) }} km</h1>
                    <!--<h1>Gesamtergebnis 154.737</h1>-->
                </template>
            </Progress>
            

            <!--div class="kgk-global-progress__notice">
                <p>Am 30. September endete unser Projekt, und wir möchten uns herzlich bei allen Teilnehmenden bedanken, die gelaufen, gewandert und spazieren gegangen sind, um Kilometer für unsere Sache zu sammeln. Eure Unterstützung hat einen bedeutenden Beitrag geleistet und ist für uns eine große Motivation weiter zu machen und das Projekt weiter auszubauen.</p>
                <p>Wir würden uns freuen, wenn ihr auch im nächsten Jahr wieder mitmacht und uns mit euren Kilometern unterstützt.</p>
                <p>Bis dahin sind wir auf euer Feedback angewiesen. Habt ihr Ideen, wie wir das Projekt weiterentwickeln können oder möchtest du das Projekt als Firma unterstützen? Wir freuen uns über jede Rückmeldung von euch.</p>
                <p>Ihr könnt euch gerne jederzeit bei Fragen oder Ideen an Clemens unter <a href="mailto:info@kilometergegenkrebs.de">info@kilometergegenkrebs.de</a> wenden.</p>
            </div-->
            <!--div class="kgk-global-progress__notice">
                <p>Toll, dass du bei Kilometer gegen Krebs mitmachst!</p>
                <p>Wir freuen uns sehr, dass du Teil unserer Laufveranstaltung bist und deine Kilometer für den guten Zweck spendest. Egal, ob du läufst, wanderst oder spazieren gehst, jeder Schritt zählt und macht einen bedeutenden Beitrag im Kampf gegen Krebs.</p>
                <p>Dein Feedback ist uns dabei sehr wichtig! Hast du Ideen, wie wir das Projekt weiterentwickeln können? Möchtest du das Projekt als Firma oder Läufer unterstützen? Wir freuen uns über jede Rückmeldung von dir.</p>
                <p>Du kannst dich gerne jederzeit bei Fragen oder Ideen an Clemens unter <a href="mailto:kilometer@krebsgesellschaft-nrw.de">kilometer@krebsgesellschaft-nrw.de</a> wenden. Lasst uns gemeinsam gegen den Krebs antreten und einen bedeutenden Unterschied machen! Jeder Schritt zählt, und zusammen können wir viel bewegen.</p>
            </div-->

            <div class="kgk-global-progress__notice">
                <h2 v-html="this.textData.text_head"></h2>
                <div v-html="this.textData.text_block"></div>
            </div>


            <!--<div class="kgk-global-progress__notice">
                <p>Über 100.000 km, das ist Wahnsinn! Wir danken unseren Teilnehmern, die dieses Jahr so fleißig Kilometer gespendet haben und den Virtual Runners für Gesamt: 12.532 km, die im Rahmen der Collogne Challenge gelaufen wurden!</p>
                <p>Wir hoffen Ihr gebt in den kommenden zwei Wochen noch einmal Gas!</p>
                <p>Wir haben vieles an Feedback, Rückmeldungen und Verbesserungsvorschlägen bekommen, dafür Danke! Ein Wunsch würde häufig genannt: „Kann man das mit dem Hochladen“ nicht einfacher machen? Man kann! In Zukunft könnt Ihr Eure Kilometer noch einfacher spenden: <b>Künftig ist der Upload eines Bildnachweises nicht mehr verpflichtend, eure Läufe werden auch ohne Nachweis gewertet.</b> Damit bleibt mehr Zeit für Dich zum Laufen, denn jeder gelaufene Kilometer hilft das eigene Krebsrisiko zu senken.</p>
                <p>Aus unserer Erfahrung können wir sagen: Unsere Läufer waren bisher alle ehrlich zu uns und auch zu sich selbst. Wir bauen darauf, dass dies auch in Zukunft so bleibt und hoffen, dass so noch mehr Menschen an unserer Aktion teilnehmen.</p>
                <p>Wir versuchen, die Aktion und die APP stetig weiter zu entwickeln, wenn du Vorschläge, Kritik oder Anregungen hast, lass es uns gerne wissen! Per Mail an <a href="mailto:kilometer@krebsgesellschaft-nrw.de">kilometer@krebsgesellschaft-nrw.de</a> oder bei Facebook als Direkt-Nachricht!</p>
            </div>-->

            <!--<div class="kgk-global-progress__notice">
                <p>Liebe Teilnehmer von #KilometerGegenKrebs, ihr seid der Wahnsinn!  Unser geplantes Ziel von 80.000 km haben wir nicht nur erreicht, sondern nahezu verdoppelt! Ganze 154.737 km sind für unsere Aktion zusammengekommen, das ist immerhin 3,8 Mal um die Erde! Das entspricht bei einer mittleren Pace von 7 Min pro km immerhin rund 18.000 Stunden Bewegung! Und das ist unser Ziel. Wir bedanken uns ganz herzlich bei allen, die uns so fleißig unterstützt haben, bei „unseren“ Läuferinnen und Läufern, aber auch bei den Teilnehmenden der Plattform <a href="https://virtualrunners.org" target="_blank">Virtualrunners.org</a>. Herzlichen Dank!</p>

                <p>Wir gehen nun in die Winterpause und überlegen uns für das Jahr 2021, was wir noch besser machen können. Falls auch ihr Anregungen, Wünsche oder Kritik habt, schreibt uns einfach eine Mail an <a href="mailto:info@kilometergegenkrebs.de" target="_blank">info@kilometergegenkrebs.de</a> Wir sind pünktlich zum Start der Laufsaison am 1. April 2021 wieder am Start! Wollt ihr auf dem Laufenden bleiben und die Anmeldung nicht verschwitzen, dann lasst uns auch das wissen!</p>

                <p>Bis dahin: Bleibt gesund und aktiv!</p>
            </div>-->
        </div>
        <div v-else-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="error">FEHLER</div>
    </div>
</template>

<script>
    import runs from '../api/runs';
    import configuration from '../api/session';
    import Progress from './easy-circular-progress/index';
    //import JSConfetti from 'js-confetti';

    //const jsConfetti = new JSConfetti();

    export default {
        name: 'GlobalProgress',
        props: {
            //msg: String
        },
        data() {
            return {
                total: null,
                goal: null,
                staticProgress: null,
                loading: false,
                error: null,
                textData:'...',
                confettiCounter:0,
            }
        },
        computed: {
            progress: function() {

                return this.goal ? (Math.round(this.total / this.goal * 100 * 10) / 10) : 0;
            },
            overflow: function() {
                return this.progress > 100 ? this.progress - 100 : 0;
            },
        },
        methods: {
            calculateProgress() {
                
                
            },
            winnerAnimation(){

                jsConfetti.addConfetti({
                    confettiColors: [
                        '#82C800', 'rgb(0, 147, 161)'
                    ],
                    confettiRadius: 6,
                    confettiNumber: 60,
                }).then(() => {
                    if(this.confettiCounter <= 4){
                        this.confettiCounter++;
                        this.winnerAnimation();
                    }
                }
                );
            }
        },
        mounted() {
            this.loading = true;

            

            runs.getTotal(
                this,
                data => {
                    this.total = data.total;
                    this.goal = data.goal;
                    this.staticProgress = data.static.map(data => {
                        this.total += data.value;
                        data.percentage = data.value / this.goal;
                        return data;
                    });
                },
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );

            configuration.frontText(
                this,
                data => {
                    this.textData = data.text;
                },
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            )

            // if(this.total >= this.goal){
            //     this.winnerAnimation();
            // }
        },
        components: {
            Progress
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    #apponline .kgk-global-progress__notice p,
    .kgk-app .kgk-global-progress__notice p,
    .kgk-global-progress__notice {
        font-weight: 400;
        max-width: 700px;
        margin: 20px auto 0 auto;
    }
</style>
